import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "./constants";

type CtaWhatsProps = {
  label?: string;
  className?: string;
};

/** botão verde de WhatsApp — CTA padrão do media kit */
const CtaWhats = ({ label = "vamos conversar", className = "" }: CtaWhatsProps) => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={`inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-green-500 px-8 py-4 text-base font-bold tracking-[-0.02em] text-black transition-transform hover:scale-[1.02] hover:bg-green-400 ${className}`}
  >
    <MessageCircle size={20} />
    {label}
  </a>
);

export default CtaWhats;
